<template>
  <section
    class="JoszakiCard max-lg:p-3 lg:p-4 rounded-md shadow-md dark:shadow-gray-900/50 border transition-shadow"
    :class="{
      'hover:shadow-xl': hoverable,
      'bg-white border-gray-300 dark:bg-gray-800 dark:border-gray-600':
        'default' === type,
      'bg-gray-50 border-gray-300 dark:bg-gray-700 dark:border-gray-600':
        'gray' === type,
      'bg-info text-white border-info-darker': 'info' === type,
      'bg-primary text-white border-primary-darker': 'primary' === type,
      'bg-gradient-to-r from-blue-50 to-blue-100 border-blue-200 dark:from-blue-900 dark:to-blue-800 dark:border-blue-700':
        'primary-alt' === type,
      'bg-success text-white border-success-darker': 'success' === type,
      'bg-gradient-to-r from-green-50 to-green-100 border-green-200 dark:from-green-900 dark:to-green-800 dark:border-green-700':
        'success-alt' === type,
      'bg-warning border-warning-darker': 'warning' === type,
      'bg-gradient-to-r from-orange-50 to-orange-100 border-orange-200 dark:from-orange-900 dark:to-orange-800 dark:border-orange-700':
        'warning-alt' === type,
      'bg-danger text-white border-danger-darker': 'danger' === type,
      'bg-error border-error-darker': 'error' === type,
      'bg-rating border-rating-darker': 'rating' === type,
    }"
  >
    <slot />
  </section>
</template>

<script>
export default {
  name: "JoszakiCard",
  props: {
    type: {
      type: String,
      default: "default",
      validator: function (val) {
        return [
          "default",
          "gray",
          "info",
          "primary",
          "primary-alt",
          "success",
          "success-alt",
          "warning",
          "warning-alt",
          "danger",
          "error",
          "rating",
        ].includes(val);
      },
    },
    hoverable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
